import { Button, Col, message, Row, TimePicker, Input, Select } from "antd";
import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { INPUT_SIZE } from "../../common/ThemeConstants";
import BasicFormComponent from "../../components/formComponent/BasicFormComponent";
import FormCheckbox from "../../components/general/FormCheckbox";
import FormSelect from "../../components/general/FormSelect";
import FormTextField from "../../components/general/FormTextField";
import {
    deleteRow,
    resetState,
    setFormFieldValue,
    setInitialState,
    setSearchFieldValue,
    submitForm
} from "../../redux/actions/basicFormAction";
import {
    SET_SUPPORTING_TABLE,
    UPDATE_FORM_FIELD
} from "../../redux/reduxConstants";
import moment from "moment";
import "./style.css";
import { compareTime } from "../../functions/dateFunctions";

const initialFormValues = {
    BranchId: null,
    BranchName: "",
    CityId: null,
    IsEnable: true,
    NTNNumber: "",
    NTNName: "",
    BusinessDayStartTime: "2011-10-05T14:48:00.000Z",
    BusinessDayEndTime: "2011-10-05T14:48:00.000Z",
    lstBranchDayTime: [],
    IsCallCenter: false,
    BranchDetail: [],
    IsWarehouse: false,
    BranchAddress: "",
    BranchPhoneNumber: ""
};

const initialSearchValues = {
    BranchId: null,
    BranchName: "",
    CityId: null,
    AreaId: null,
    IsEnable: true,
    NTNNumber: "",
    NTNName: "",
    BusinessDayStartTime: "2011-10-05T14:48:00.000Z",
    BusinessDayEndTime: "2011-10-05T14:48:00.000Z",
    lstBranchDayTime: [],
    IsCallCenter: false,
    BranchDetail: [],
    IsWarehouse: false,
    BranchAddress: ""
};

const columns = [
    {
        title: "Branch Id",
        dataIndex: "BranchId",
        key: "BranchId"
    },
    {
        title: "Branch Name",
        dataIndex: "BranchName",
        key: "BranchName"
    },
    {
        title: "City",
        dataIndex: "CityName",
        key: "CityName"
    },
    {
        title: "Company Id",
        dataIndex: "CompanyId",
        key: "CompanyId"
    },
    

    
    {
        title: "Call Center Enabled",
        key: "IsCallCenter",
        render: (record) => {
            return (
                <input
                    type="checkbox"
                    checked={record.IsCallCenter}
                    onChange={() => { }}
                />
            );
        }
    },
    {
        title: "Product Enable",
        key: "IsEnable",
        render: (record) => {
            return (
                <input type="checkbox" checked={record.IsEnable} onChange={() => { }} />
            );
        }
    },
    {
        title: "Warehouse",
        key: "IsWarehouse",
        render: (record) => {
            return (
                <input
                    type="checkbox"
                    checked={record.IsWarehouse}
                    onChange={() => { }}
                />
            );
        }
    }
];

const Branches = () => {
    const dispatch = useDispatch();
    const controller = new window.AbortController();
    const userData = useSelector((state) => state.authReducer);
    const [updateId, setUpdateId] = useState(null);

    const [copyOfArea, setCopyOfArea] = useState([]);
    const [areaToShow, setAreasToShow] = useState([]);
    const [selectAll, setSelectAll] = useState(false);
    const [activeTab, setActiveTab] = useState("areas");
    const [branchTimingData, setBranchTimingData] = useState([]);



    // area simplified...............................................................code start here
    const [areas, setAreas] = useState([]);

    const [settingGroups, setSettingGroups] = useState([{
        deliveryCharges: 0,
        deliveryTime: 0,
        minimumOrder: 0,
        OrderAmount_DeliveryChargesWaiveOffLimit: 0,
        selectedAreaIds: []
    }]);
    console.log("checking setting groups ", settingGroups,);

    const addSettingGroup = () => {
        setSettingGroups([...settingGroups, {
            deliveryCharges: 0,
            deliveryTime: 0,
            OrderAmount_DeliveryChargesWaiveOffLimit: 0,
            minimumOrder: 0,
            selectedAreaIds: []
        }]);
    };

    const handleSettingChange = (index, field, value) => {
        const updatedGroups = [...settingGroups];
        updatedGroups[index][field] = value;
        setSettingGroups(updatedGroups);
    };

    const handleAreasChange = (index, selectedIds) => {
        console.log("checking selected ids ", selectedIds);
        const updatedGroups = [...settingGroups];
        updatedGroups[index].selectedAreaIds = selectedIds;
        setSettingGroups(updatedGroups);

        console.log("checking updated groups ", updatedGroups);
    };

    const removeGroup = (index) => {
        if (settingGroups.length > 1) {
            const updatedGroups = settingGroups.filter((_, i) => i !== index);
            setSettingGroups(updatedGroups);
        }
    };


    // area simplified...............................................................code end here



    const [selectAllChangeObj, setSelectAllChangeObj] = useState({
        BranchId: null,
        AreaId: null,
        DeliveryTime: null,
        DeliveryTime1: null,
        DeliveryTime2: null,
        DeliveryTime3: null,
        MinimumOrder: null,
        DeliveryCharges: null,
        AlternateBranch1: null,
        AlternateBranch2: null,
        AlternateBranch3: null,
        IsEnable: true
    });

    const {
        formFields,
        searchFields,
        itemList,
        formLoading,
        tableLoading,
        supportingTable
    } = useSelector((state) => state.basicFormReducer);
    const userInfo = useSelector((state) => state.authReducer);

    const closeForm = () => {

        setCopyOfArea([]);
        setAreasToShow([]);
        setSettingGroups(
            [{
                deliveryCharges: 0,
                deliveryTime: 0,
                minimumOrder: 0,
                OrderAmount_DeliveryChargesWaiveOffLimit: 0,
                selectedAreaIds: []
            }]
        )
        setBranchTimingFormField({});
        setActiveTab("areas");
        setSelectAllChangeObj({
            BranchId: null,
            AreaId: null,
            DeliveryTime: null,
            DeliveryTime1: null,
            DeliveryTime2: null,
            DeliveryTime3: null,
            MinimumOrder: null,
            DeliveryCharges: null,
            AlternateBranch1: null,
            AlternateBranch2: null,
            AlternateBranch3: null,
            IsEnable: true
        });

        dispatch(
            setInitialState(
                "/CrudBranch",
                initialFormValues,
                initialFormValues,
                initialSearchValues,
                controller,
                userData
            ))
    };


    useEffect(() => {
        dispatch(
            setInitialState(
                "/CrudBranch",
                initialFormValues,
                initialFormValues,
                initialSearchValues,
                controller,
                userData
            )
        );

        return () => {
            controller.abort();
            dispatch(resetState());
        };
    }, []);


    useEffect(() => {
        if (supportingTable?.Table5 && Array.isArray(supportingTable.Table5)) {
            setBranchTimingData(supportingTable.Table5);

            setAreas(supportingTable.Table2);
        }
    }, [supportingTable]);



    useEffect(() => {
        if (updateId !== null) {
            // Get branch details
            const branchDetails = itemList.find((item) => item.BranchId === updateId);

            // Dispatch main branch details to form
            dispatch({
                type: UPDATE_FORM_FIELD,
                payload: branchDetails
            });

            // Get existing delivery settings for areas
            const filteredAreas = supportingTable.Table3.filter(
                (item) => item.BranchId === updateId
            );

            // Transform flat array into grouped settings format
            const groupedSettings = filteredAreas.reduce((acc, area) => {
                const key = `${area.DeliveryTime}-${area.DeliveryCharges}-${area.MinimumOrder}`;

                if (!acc[key]) {
                    acc[key] = {
                        deliveryCharges: area.DeliveryCharges,
                        deliveryTime: area.DeliveryTime,
                        minimumOrder: area.MinimumOrder,
                        OrderAmount_DeliveryChargesWaiveOffLimit: area.DeliveryChargesWaiveOffLimit,
                        selectedAreaIds: []
                    };
                }

                acc[key].selectedAreaIds.push(area.AreaId);
                return acc;
            }, {});

            console.log("checking grouped settings ", Object.values(groupedSettings));

            // Convert to array and set state
            setSettingGroups(Object.values(groupedSettings));
        }

        setUpdateId(null);
    }, [updateId]);







    const handleSearchChange = (data) => {
        dispatch(setSearchFieldValue(data));
    };

    const handleFormChange = (data) => {
        dispatch(setFormFieldValue(data));
        if (data.name === "CityId") {
            const areasToShowTempArr = [];

            copyOfArea.map((x, index) => {
                if (x.CityId === data.value) {
                    areasToShowTempArr.push(copyOfArea[index]);
                }
            });
            if (areasToShowTempArr.length > 0) {
                setAreasToShow([...areasToShowTempArr]);
            } else {
                setAreasToShow([]);
            }
        }
    };


    const setAreaToShow = () => {
        const areasToPush = [];
        supportingTable?.Table2?.filter((item, i) => {
            const index = supportingTable?.Table3?.findIndex(
                (x) => x.AreaId === item.AreaId
            );
            if (index === -1) {
                areasToPush.push(supportingTable.Table2[i]);
            }
        });
        setCopyOfArea(areasToPush);
    };






    const handleSearchSubmit = (e) => {
        e.preventDefault();
        dispatch(
            setInitialState(
                "/CrudBranch",
                searchFields,
                initialFormValues,
                searchFields,
                controller,
                userData
            )
        );
    };

    const handleDeleteRow = (branchId) => {
        delete formFields.BranchId;
        dispatch(
            deleteRow(
                "/CrudBranch",
                {
                    ...formFields,
                    BranchId: branchId,
                    BranchDetail: [],
                    BranchName: "",
                    CityId: null,
                    IsEnable: true,
                    NTNNumber: "",
                    NTNName: "",
                    BusinessDayStartTime: "2011-10-05T14:48:00.000Z",
                    BusinessDayEndTime: "2011-10-05T14:48:00.000Z",
                    IsCallCenter: true,
                    UserIP: "1.1.1.1",
                    BranchDetail: []
                },
                controller,
                userData,
                (tables) => {
                    delete tables.Table;
                    const tablesToSet = {
                        Table1: tables.Table2,
                        Table2: tables.Table3,
                        Table3: tables.Table4
                    };
                    dispatch({ type: SET_SUPPORTING_TABLE, payload: tablesToSet });
                }
            )
        );
    };














    // Branch day wise timing ..............................................................................
    const [weekDays, setWeekDays] = useState([]);
    const [branchTimingFormField, setBranchTimingFormField] = useState({});
    const [activeDayTab, setActiveDayTab] = useState(4); // default to Sunday

    console.log("checking week days ", weekDays);

    useEffect(() => {
        if (supportingTable?.Table4?.length > 0) {
            const mappedDays = supportingTable.Table4.map(day => ({
                dayId: day.SetupDetailId,
                name: day.SetupDetailName
            }));

            setWeekDays(mappedDays);

            const initialTiming = {};
            mappedDays.forEach(day => {
                initialTiming[day.dayId] = [{ startTime: "", endTime: "" }];
            });

            setBranchTimingFormField(initialTiming);
        }
    }, [supportingTable?.Table4]);


    // copy timings to all days
    const copyToAllDays = () => {
        const currentDayTimings = branchTimingFormField[activeDayTab];
        const newFormFields = {};

        weekDays.forEach((day) => {
            newFormFields[day.dayId] = [...currentDayTimings.map(slot => ({ ...slot }))]; // deep clone
        });

        setBranchTimingFormField(newFormFields);
        // ✅ Success message
        message.success("Timings copied to all days successfully!");
    };

    // handle change in time fields
    const handleChangeTime = (dayId, idx, field, value) => {
        setBranchTimingFormField((prev) => {
            const updated = [...prev[dayId]];
            updated[idx][field] = value;
            return {
                ...prev,
                [dayId]: updated,
            };
        });
    };
    // ........................................................................................................






    const handleFormSubmit = (e, id = 2, _, closeForm) => {



        if (selectAllChangeObj.DeliveryTime === "0") {
            message.error("Delivery Time cannot be zero");
            return;
        }

        // ✅ Build lstBranchDayTime directly here
        const branchId = formFields.BranchId; // Assuming this is correct
        const lstBranchDayTime = [];

        Object.entries(branchTimingFormField).forEach(([dayId, times]) => {
            times.forEach((t) => {
                if (t.startTime && t.endTime) {
                    lstBranchDayTime.push({
                        BranchId: branchId,
                        DayId: parseInt(dayId),
                        StartTime: t.startTime,
                        EndTime: t.endTime,
                    });
                }
            });
        });

        // todo here
        e.preventDefault();


        const result = settingGroups.flatMap(group =>
            group.selectedAreaIds.map(areaId => ({
                BranchId: branchId,
                AreaId: areaId,
                DeliveryCharges: group.deliveryCharges,
                MinimumOrder: group.minimumOrder,
                DeliveryTime: group.deliveryTime,
                OrderAmount_DeliveryChargesWaiveOffLimit: group.OrderAmount_DeliveryChargesWaiveOffLimit,
            }))
        );

        let BranchDetail = result;

        dispatch(
            submitForm("/CrudBranch", { ...formFields, lstBranchDayTime, BranchDetail }, initialFormValues, controller, userData, id,
                (tables) => {
                    delete tables.Table;
                    const tablesToSet = {
                        Table1: tables.Table2,
                        Table2: tables.Table3,
                        Table3: tables.Table4
                    };
                    dispatch({ type: SET_SUPPORTING_TABLE, payload: tablesToSet });
                    closeForm();
                }
            )
        );

        setAreasToShow([]);
        setCopyOfArea([]);


        setSelectAllChangeObj({
            BranchId: null,
            AreaId: null,
            DeliveryTime: null,
            DeliveryTime1: null,
            DeliveryTime2: null,
            DeliveryTime3: null,
            MinimumOrder: null,
            DeliveryCharges: null,
            AlternateBranch1: null,
            AlternateBranch2: null,
            AlternateBranch3: null,
            IsEnable: true
        });

    };




    const setBranchId = (fn) => {
        const branchId = fn();

        // 1. Set the branch ID to update
        setUpdateId(branchId);

        // Save to localStorage
        localStorage.setItem("editBranchId", branchId);
    };


    const handleEditBranchTiming = () => {
        const storedBranchId = localStorage.getItem("editBranchId");

        if (!storedBranchId) {
            console.warn("No branchId found in localStorage");
            return;
        }

        const branchIdInt = parseInt(storedBranchId);

        const filteredTimings = branchTimingData.filter(
            (item) => item.BranchId === branchIdInt
        );

        const normalized = weekDays.reduce((acc, { dayId }) => {
            const entries = filteredTimings
                .filter(item => item.DayId === dayId)
                .map(item => ({
                    startTime: item.StartTime?.slice(0, 5) || "",
                    endTime: item.EndTime?.slice(0, 5) || ""
                }));

            acc[dayId] = entries.length ? entries : [{ startTime: "", endTime: "" }];
            return acc;
        }, {});

        if (normalized) {
            setBranchTimingFormField(normalized);
        }
    };




    const searchPanel = (
        <Fragment>
            <FormTextField
                colSpan={4}
                label="Branch"
                name="BranchName"
                size={INPUT_SIZE}
                value={searchFields.BranchName || ""}
                onChange={handleSearchChange}
            />
            <FormSelect
                colSpan={4}
                listItem={supportingTable.Table1 || []}
                idName="CityId"
                valueName="CityName"
                size={INPUT_SIZE}
                name="CityId"
                label="City"
                value={searchFields.cityName}
                onChange={handleSearchChange}
                allowClear={true}
            />
        </Fragment>
    );

    const formPanel = (
        <Fragment>
            <FormTextField
                colSpan={4}
                label="Branch"
                name="BranchName"
                size={INPUT_SIZE}
                value={formFields.BranchName || ""}
                onChange={handleFormChange}
                required={true}
            />
            <FormTextField
                colSpan={4}
                label="Tax Number"
                name="NTNNumber"
                size={INPUT_SIZE}
                value={formFields.NTNNumber}
                onChange={handleFormChange}
                required={true}
            />
            <FormTextField
                colSpan={4}
                label="Tax Name"
                name="NTNName"
                size={INPUT_SIZE}
                value={formFields.NTNName}
                onChange={handleFormChange}
                required={true}
            />
            <FormSelect
                colSpan={4}
                listItem={supportingTable.Table1 || []}
                idName="CityId"
                valueName="CityName"
                size={INPUT_SIZE}
                name="CityId"
                label="City"
                value={formFields.CityId}
                onChange={handleFormChange}
                required={true}
            />

            <FormTextField
                colSpan={4}
                label="Branch Address"
                name="BranchAddress"
                size={INPUT_SIZE}
                value={formFields.BranchAddress || ""}
                onChange={handleFormChange}
            />
            <FormTextField
                colSpan={4}
                label="Branch Phone Number"
                name="BranchPhoneNumber"
                size={INPUT_SIZE}
                value={formFields.BranchPhoneNumber || ""}
                onChange={handleFormChange}

            />
            <FormCheckbox
                colSpan={4}
                checked={formFields.IsCallCenter}
                name="IsCallCenter"
                onChange={handleFormChange}
                label="Call Center"
            />
            <FormCheckbox
                colSpan={4}
                checked={formFields.IsEnable}
                name="IsEnable"
                onChange={handleFormChange}
                label="Enabled"
            />
            <FormCheckbox
                colSpan={4}
                checked={formFields.IsWarehouse}
                name="IsWarehouse"
                onChange={handleFormChange}
                label="Warehouse"
            />















            {/* Tabs */}
            <div className="flex items-center justify-center w-full space-x-2 ">
                <div className="bg-gray-100 flex gap-2 p-1 rounded-full">
                    <div
                        onClick={() => setActiveTab("areas")}
                        className={`cursor-pointer px-4 py-2 rounded-full ${activeTab === "areas" ? "bg-[#017971] text-white" : "bg-gray-100 text-gray-700"
                            }`}
                    >
                        Branch Areas
                    </div>

                    <div
                        onClick={() => {
                            handleEditBranchTiming();
                            setActiveTab("timing");


                        }}
                        className={` cursor-pointer px-4 py-2 rounded-full ${activeTab === "timing" ? "bg-[#017971] text-white" : "bg-gray-100 text-gray-700"
                            }`}
                    >
                        Branch Timing
                    </div>

                </div>
            </div>


            {activeTab === "timing" ? (
                <div className="mt-8 mx-auto flex items-center justify-center w-full space-x-2 mb-4">
                    <div className="px-6 pb-6 w-full mx-auto flex flex-col items-center justify-center">

                        {/* Tabs as divs */}
                        <div className="inline-flex space-x-3 mb-6 mx-auto bg-gray-100 p-1 rounded-lg">
                            {weekDays?.map((day) => (
                                <div
                                    key={day.dayId}
                                    onClick={() => setActiveDayTab(day.dayId)}
                                    className={`px-4 py-2 cursor-pointer rounded-full ${activeDayTab === day.dayId
                                        ? "bg-[#017971] text-white"
                                        : ""
                                        }`}
                                >
                                    {day.name}
                                </div>
                            ))}
                        </div>

                        {/* Active Day Content */}
                        <div className="">

                            <div className="text-center mb-4">
                                <Button
                                    onClick={copyToAllDays}
                                    className=" text-black px-4 pb-2 rounded-full  transition"
                                >
                                    Copy to All Days
                                </Button>
                            </div>

                            {branchTimingFormField[activeDayTab]?.map((time, idx) => (
                                <div className="flex gap-2 mb-2" key={idx}>

                                    <FormTextField
                                        type="time"
                                        style={{ width: "250px" }}
                                        placeholder="Start Time"
                                        value={branchTimingFormField[activeDayTab][idx].startTime}
                                        required={true}
                                        label="Start Time"
                                        onChange={(e) => {
                                            handleChangeTime(activeDayTab, idx, "startTime", e.value);
                                            console.log("checking start time what coming in event ", e, e.value);
                                        }}
                                    />


                                    <FormTextField
                                        type="time"
                                        style={{ width: "250px" }}
                                        placeholder="End Time"
                                        value={branchTimingFormField[activeDayTab][idx].endTime}
                                        required={true}
                                        label="End Time"
                                        onChange={(e) => {
                                            handleChangeTime(activeDayTab, idx, "endTime", e.value);
                                        }}
                                    />

                                </div>
                            ))}



                            {/* Add More Time Slot */}
                            {branchTimingFormField[activeDayTab]?.length < 3 && (
                                <div
                                    className="text-[#017971] w-8 h-8 rounded-full mx-auto bg-gray-100 flex items-center justify-center text-2xl cursor-pointer"
                                    onClick={() =>
                                        setBranchTimingFormField((prev) => ({
                                            ...prev,
                                            [activeDayTab]: [
                                                ...prev[activeDayTab],
                                                { startTime: "", endTime: "" },
                                            ],
                                        }))}
                                >
                                    +
                                </div>
                            )}
                        </div>

                    </div>
                </div>










            ) : (

                <div className="max-w-5xl mx-auto  ">
                    {settingGroups.map((group, index) => (
                        <div key={index} className="mb-6 rounded-lg   p-4 border">
                            <div className="flex justify-between items-center mb-4">
                                <h3 className="text-lg font-semibold">Delivery Zone {index + 1}</h3>
                                {settingGroups.length > 1 && (
                                    <Button
                                        danger
                                        onClick={() => removeGroup(index)}
                                        className="bg-red-500 hover:bg-red-600 text-white rounded-full"
                                    >
                                        Remove Group
                                    </Button>
                                )}
                            </div>

                            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-2 mb-4">
                                <CustomInput
                                    label="Delivery Time (minutes)"
                                    value={group.deliveryTime}
                                    onChange={(e) => handleSettingChange(index, 'deliveryTime', e.target.value)}
                                />
                                <CustomInput
                                    label="Delivery Charges (Rs.)"
                                    value={group.deliveryCharges}
                                    onChange={(e) => handleSettingChange(index, 'deliveryCharges', e.target.value)}
                                />
                                <CustomInput
                                    label="Minimum Order (Rs.)"
                                    value={group.minimumOrder}
                                    onChange={(e) => handleSettingChange(index, 'minimumOrder', e.target.value)}
                                />
                                <CustomInput
                                    label="Waive Off Amount (Rs.)"
                                    value={group.OrderAmount_DeliveryChargesWaiveOffLimit}
                                    onChange={(e) =>
                                        handleSettingChange(index, 'OrderAmount_DeliveryChargesWaiveOffLimit', e.target.value)
                                    }
                                />
                            </div>


                            <Select
                                mode="multiple"
                                placeholder="Select areas for these settings"
                                value={group.selectedAreaIds}
                                onChange={(value) => handleAreasChange(index, value)}
                                showSearch
                                optionFilterProp="label"
                                className="w-full"
                                options={
                                    areas
                                        .filter(area => area.BranchId === null || area.BranchId === Number(localStorage.getItem("editBranchId") || 0))
                                        .map(area => ({
                                            label: area.AreaName,
                                            value: area.AreaId,
                                            disabled: settingGroups.some(
                                                (g, i) => i !== index && g.selectedAreaIds.includes(area.AreaId)
                                            )
                                        }))
                                }
                            />
                        </div>
                    ))}

                    <div className="flex gap-3 justify-end mt-6">
                        <Button
                            type="dashed"
                            onClick={addSettingGroup}
                            className="border-dashed border-gray-300 hover:border-blue-500 text-blue-500"
                        >
                            + Add Another Settings Group
                        </Button>

                        {/* <Button
                            type="primary"
                            onClick={handleSubmit}
                            className="bg-blue-500 hover:bg-blue-600 text-white"
                        >
                            Save All Settings
                        </Button> */}
                    </div>
                </div>

            )}




        </Fragment>
    );

    return (
        <BasicFormComponent
            formTitle="Branches"
            searchPanel={searchPanel}
            formPanel={formPanel}
            searchSubmit={handleSearchSubmit}
            onFormSave={handleFormSubmit}
            formWidth="95vw"
            formLoading={formLoading}
            tableLoading={tableLoading}
            tableColumn={columns}
            tableRows={itemList}
            editRow={setBranchId}
            deleteRow={handleDeleteRow}
            fields={initialFormValues}
            actionID="BranchId"
            onFormClose={closeForm}
            onFormOpen={setAreaToShow}
            crudTitle="Branch"
        />
    );
};

export default Branches;


const CustomInput = ({ label, value, onChange, placeholder = "", type = "number" }) => (
    <div className="flex flex-col gap-1">
        <label className="text-sm font-semibold text-gray-700">{label}</label>
        <input
            type={type}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            className="border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
        />
    </div>
);
